import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { ConfirmationContainer, ConfirmationIcon, ConfirmationText } from "./styles";
import { SignInButton } from "~/pages/Auth/SingIn/styles";

function Confirmation(props) {
  const history = useHistory();
  const emailSelected = useSelector(
    (state) => state.accessReducer.contact.selectedEmail
  );

  return (
    <ConfirmationContainer>
      <ConfirmationIcon className="fa fa-check-circle-o" />
      <ConfirmationText className="mt-4">
        <p>Um e-mail de ativação foi enviado para:</p>
        <h6><b>{emailSelected}</b></h6>
        <p className="mt-4">Clique no link para ativar seu usuário</p>
      </ConfirmationText>

      <SignInButton type="submit" className="mt-3" onClick={() => history.push("/")}>
        <span>Acessar</span>
      </SignInButton>
    </ConfirmationContainer>
  );
}

export default Confirmation;
